import React, { useState } from 'react';
import { useLazyUserMedicationLastedQuery } from '../../../graphql/graphql';

export default function usePermanentMedication() {
	const [getPermanentMedicationQuery, { data, isLoading }] =
		useLazyUserMedicationLastedQuery();
	const [page, setPage] = useState(1);
	const getPermanentMedication = (filter: any) => {
		getPermanentMedicationQuery({
			where: filter,
			pagination: { skip: (page - 1) * 20 },
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getPermanentMedication,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
